
import { BracketExpressionResolver, ILocatedEntity } from './bracket-expression-resolver';
import { IExpressionResolver, ResolutionErrorKind, IExpressionResolution, failedExpressionResolution, IApplicability } from 'app/model/expressions/expression-resolution';
import { Pipeline } from 'app/model/pipeline/pipeline';
import { SetVariableActivity } from 'app/model/pipeline/variables.activity';
import { AppendVariableActivity } from 'app/model/pipeline/variable-append.activity';
import { Named, Owned } from 'app/model/base/named';
import { Variable } from 'app/model/base/variable';
import { stringsAreEqualCaseInsensitive } from 'app/shared/utils/string.util';
import { Dataset } from 'shell-models-lib';

export class VariablesResolver extends BracketExpressionResolver {
    protected readonly _entityNotReferenceableResolutionError = ResolutionErrorKind.VariableNotReferencable;
    protected readonly _missingEntityNameResolutionError = ResolutionErrorKind.MissingVariableNameResolutionError;
    protected readonly _selfReferencingResolutionError = ResolutionErrorKind.SelfReferencingVariable;
    public constructor(
        _entity: Owned,
        _expressionResolversCallback: () => IExpressionResolver[]) {
        super(_entity, _expressionResolversCallback);
    }
    public resolve(expression: string, ignoreStart?: boolean): IExpressionResolution {
        const entity = super.getEntity();
        if (entity instanceof SetVariableActivity || entity instanceof AppendVariableActivity) {
            if (expression.includes(`variables('${entity.variables.name}'`)) {
                return failedExpressionResolution(expression, {
                    kind: this._selfReferencingResolutionError,
                    details: { entity }
                });
            }
        }

        return super.resolve(expression, ignoreStart);
    }

    public checkApplicability(entity: Owned): IApplicability {
        const applicability = super.checkApplicability(entity);

        if (!applicability.isApplicable) {
            if (__IS_FABRIC_DPE__ && entity?.concept instanceof Dataset) {
                applicability.isApplicable = true; // Fabric doesn't have dataset concept. Ingore this for Fabric
            } else {
                applicability.error = {
                    kind: ResolutionErrorKind.VariablesUnsupported,
                    details: { target: entity }
                };
    
                applicability.treatAsWarning = true;
            }
        }

        return applicability;
    }

    protected locateEntity(fromEntity: Owned, entityName: string): ILocatedEntity {
        if (!fromEntity) {
            return null;
        }
        while (fromEntity.owner) {
            fromEntity = fromEntity.owner;
        }
        const rootPipeline = fromEntity as Pipeline;
        let entity: Named;

        if (rootPipeline) {
            entity = rootPipeline.variables.find(
                (variable: Variable) => stringsAreEqualCaseInsensitive(variable.name, entityName));
        }

        if (entity) {
            return {
                isExcluded: false,
                named: entity
            };
        }

        return null;
    }
    protected getPrefix(ignoreStart: boolean): string {
        return (ignoreStart ? '' : '@') + 'variables';
    }

}
